import React from "react";
import Card from "react-bootstrap/Card";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hola a todos, Soy <span className="purple">Fernando Aldama </span>
            de <span className="purple"> Itauguá, Paraguay.</span>
            <br />
            Soy egresado en Full Stack Developer en Henry.
            <br />
            <br />
            Aparte de la programación, algunas otras actividades que me
            encantan!
          </p>
          <ul>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Jugar Videojuegos
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Aprender sobre nuevas
              tecnologías
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Viajar
            </li>
          </ul>

          {/* <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Soumyajit</footer> */}
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
